/**
 * Typed access to Vite env vars.
 *
 * Only variables with `VITE_` prefix are exposed to the client bundle.
 * See: https://vitejs.dev/guide/env-and-mode
 */

interface AppConfig {
  apiBaseUrl: string
  appName: string
  appVersion: string
  /** Build-time fallback. Runtime /api/v1/config overrides this after app boot. */
  mlopsEnabled: boolean
  /**
   * HuggingFace OAuth authorize URL. Null until GDEV-40 (HF 토큰 발급) 완료.
   * 설정 시 LoginModal 의 HF SSO 버튼이 해당 URL 로 리다이렉트.
   */
  hfOauthUrl: string | null
  isDev: boolean
  isProd: boolean
}

function readEnv(key: keyof ImportMetaEnv, fallback: string): string {
  const value = import.meta.env[key]
  return typeof value === 'string' && value.length > 0 ? value : fallback
}

function readBooleanEnv(key: keyof ImportMetaEnv, fallback: boolean): boolean {
  const value = import.meta.env[key]
  if (typeof value !== 'string' || value.length === 0) return fallback
  return !['0', 'false', 'off', 'no'].includes(value.trim().toLowerCase())
}

export const config: AppConfig = {
  apiBaseUrl: readEnv('VITE_API_BASE_URL', 'http://localhost:18000/api/v1'),
  appName: readEnv('VITE_APP_NAME', 'K-Humanoid Hub'),
  appVersion: readEnv('VITE_APP_VERSION', '0.0.0'),
  mlopsEnabled: readBooleanEnv('VITE_MLOPS_ENABLED', true),
  hfOauthUrl: import.meta.env.VITE_HF_OAUTH_URL ?? null,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
}
